import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[noSpace]'
})
export class NoSpaceDirective {
  @HostListener('input', ['$event'])
  onInputChange(event: InputEventWrapper): void {
    const { target } = event;
    const { value } = target;
    (event.target as HTMLInputElement).value = value ? value.replace(/\s/g, '') : value;
  }
}
